import { ArrowRight, TriangleAlert } from "lucide-react";
import type { ReactNode } from "react";

import { FOCUS_RING_CLASS } from "@/lib/a11y";
import { cn } from "@/lib/utils";

/** Faixa de aviso amarela das telas do Configuration Server, com um atalho opcional à direita. */
export function StageAlert({
  message, action,
}: {
  message: string;
  action: { label: ReactNode; onClick: () => void; arrow?: boolean; disabled?: boolean } | null;
}) {
  return (
    <div
      role="alert"
      className="mb-4 flex flex-wrap items-center gap-3 rounded-lg border border-[#ffc83d] bg-[#fff8e1] px-4 py-3"
    >
      <span
        aria-hidden="true"
        className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-[rgba(255,200,61,0.25)] text-[#7a5600]"
      >
        <TriangleAlert className="h-4 w-4" />
      </span>
      <p className="m-0 text-sm font-semibold text-[#6b5200]">{message}</p>
      {action && (
        <button
          type="button"
          onClick={action.onClick}
          disabled={action.disabled}
          className={cn(
            "ml-auto inline-flex disabled:cursor-not-allowed disabled:opacity-60 h-8 items-center gap-1.5 rounded-md border border-[rgba(176,125,0,0.35)] bg-white px-3 text-[13px] font-medium text-[#6b5200] transition-colors hover:bg-[rgba(255,200,61,0.12)]",
            FOCUS_RING_CLASS,
          )}
        >
          {action.label}
          {action.arrow && <ArrowRight aria-hidden="true" className="h-3.5 w-3.5" />}
        </button>
      )}
    </div>
  );
}

